import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getSlackInstallUrl, getBackendInstallUrl } from '@/utils/slack-oauth';

/**
 * SlackInstallButton component
 * 
 * This component handles the "Add to Slack" button with proper OAuth flow
 * It attempts to get a state token from the backend first, but falls back
 * to direct OAuth if necessary for App Store compliance
 */
const SlackInstallButton: React.FC = () => {
  const [installUrl, setInstallUrl] = useState<string>(getBackendInstallUrl());
  
  useEffect(() => {
    // For App Store compliance, we'll use the direct OAuth URL
    // This meets the requirement of going directly to Slack's OAuth flow 
    // without an intermediate step
    setInstallUrl(getSlackInstallUrl());
  }, []);

  return (
    <a href={installUrl}>
      <motion.img
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        alt="Add to Slack"
        height="40"
        width="139"
        src="https://platform.slack-edge.com/img/add_to_slack.png"
        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        className="rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
      />
    </a>
  );
};

export default SlackInstallButton;